module.exports = __webpack_public_path__ + "img/docker.7d66b014.png";